export var AccountStatusType;
(function (AccountStatusType) {
    AccountStatusType["SignupPending"] = "SignupPending";
    AccountStatusType["Active"] = "Active";
})(AccountStatusType || (AccountStatusType = {}));
//# sourceMappingURL=user.model.js.map